const debounce = (callback, delay, currentTimer) => {
  return (...args) => {
    clearTimeout(currentTimer);
    return setTimeout(() => callback(...args), delay);
  }
}

export default debounce;


// WEBPACK FOOTER //
// ./src/helpers/debounce.js